import actions from "./actions";

const {
    FETCH_CT_SCHEDULE_LIST,
    FETCH_CT_SCHEDULE,
    RESET_CT_SCHEDULE_FORM
} = actions;

const initState = {
    // Stores the list, pagination info, and total count
    ctSchedules: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    // Stores the specific CT being edited or viewed
    ctSchedule: { _id: null }
};

const CTScheduleReducer = (state = initState, action) => {
    const { type, data } = action;

    switch (type) {
        case FETCH_CT_SCHEDULE_LIST:
            return {
                ...state,
                ctSchedules: data
            };
        case FETCH_CT_SCHEDULE:
            return {
                ...state,
                ctSchedule: data
            };
        case RESET_CT_SCHEDULE_FORM:
            return {
                ...state,
                ctSchedule: initState.ctSchedule
            };
        default:
            return state;
    }
};

export default CTScheduleReducer;